import settings from "../settings";



export const apiUrls = {
  getToken: settings.apiBaseUrl + '/gettoken',
  generalTerms: settings.apiBaseUrl + '/termsandconditions',
  acceptTerms: settings.apiBaseUrl + '/termsandconditions',
  services: settings.apiBaseUrl + '/services',
  postServices: settings.apiBaseUrl + '/services',
  servicesInfo: settings.apiBaseUrl + '/dashboard/servicesinfo',
  dashboardDocuments: settings.apiBaseUrl + '/dashboard/documents',
  getDocuments: settings.apiBaseUrl + '/documents',
  getDocumentAttachment: settings.apiBaseUrl + '/documents/attachments',
  postDocumentAttachments: settings.apiBaseUrl + '/documents/attachments',
  getDocumentTemplate: settings.apiBaseUrl + '/documents/templates',
  dashboardContracts: settings.apiBaseUrl + '/dashboard/contracts',
  getContracts: settings.apiBaseUrl + '/contracts',
  getContractAttachment: settings.apiBaseUrl + '/contracts/attachments',
  postContractAttachment: settings.apiBaseUrl + '/contracts/attachments',
  acceptContractAttachment: settings.apiBaseUrl + '/contracts/approve',
  changeContractIbanSwift: settings.apiBaseUrl + '/contracts/details',
  dashboardRoutes: settings.apiBaseUrl + '/dashboard/routes',
  getRoutes: settings.apiBaseUrl + '/routes',
  postRoutes: settings.apiBaseUrl + '/routes',
  deleteRoutes: settings.apiBaseUrl + '/deleteroutes',
  countries: settings.apiBaseUrl + '/countries',
  getFleet: settings.apiBaseUrl + '/fleet',
  getFleetInfo: settings.apiBaseUrl + '/fleetinfo',
  postFleet: settings.apiBaseUrl + '/fleet',
  settingsGetContacts: settings.apiBaseUrl + '/contacts',
  settingsModifyContact: settings.apiBaseUrl + '/contacts/edit',
  settingsCreateContact: settings.apiBaseUrl + '/contacts/create',
  settingsDeleteContact: settings.apiBaseUrl + '/contacts/delete',
  settingsChangeAdmin: settings.apiBaseUrl + '/contacts/admin',
  getRoles: settings.apiBaseUrl + '/contacts/roles',
  getProfile: settings.apiBaseUrl + '/profile/contact',
  postProfile: settings.apiBaseUrl + '/profile/contact',
  getBusinessProfile: settings.apiBaseUrl + '/profile/businessprofile',
  postBusinessProfile: settings.apiBaseUrl + '/profile/businessprofile',
  getAccountStatus: settings.apiBaseUrl + '/accountstatus',
  getNotificationsToRead: settings.apiBaseUrl + '/notifications',
  getNotificationsBulk: settings.apiBaseUrl + '/notifications/bulk',
  readNotification: settings.apiBaseUrl + '/notifications',
  readAllNotifications: settings.apiBaseUrl + '/notifications/bulk',


  getLastOrdersPositions: settings.telematicsUrl + "/OMGetLastOrdersPositions",
  getAllOrdersPositions: settings.telematicsUrl + "/OMGetAllOrdersPositions",



  getTrips: settings.apiExecutionUrl + '/trips',
  getTripHeaderById: settings.apiExecutionUrl + '/trip/{id}',
  putTripAcceptanceById: settings.apiExecutionUrl + "/trip/acceptance",
  getTripAcceptanceById: settings.apiExecutionUrl + "/trip/acceptance",
  getTripTimelineById: settings.apiExecutionUrl + '/trip/{id}/stops',
  getTripNotesById: settings.apiExecutionUrl + '/trip/{id}/notes',
  getTripsCount: settings.apiExecutionUrl + '/tripscount',
  getTripLicensePlates: settings.apiExecutionUrl + "/trip/{id}/licenseplates",
  putTripLicensePlate: settings.apiExecutionUrl + "/trip/licenseplates",
  transportPDF: settings.apiExecutionUrl + "/document/transportpdf",


  uploadPOD: settings.documentaleUrl + "/buffer/insert",
  getPODDocNumbers: settings.documentaleUrl + "/v3/searches",
  sendTripDocument: settings.documentaleUrl + "/profiles",
  getDocumentDetails: settings.documentaleUrl + '/v2/Documents/{id}',
  getTermsAndConditions: settings.apiBaseUrl + "/termsandconditions",
  getDocumentsNote: settings.documentaleUrl + '/Notes/{id}',


  postDriver: settings.vlmMasterDataUrl + "/driver",
  putDriver: settings.vlmMasterDataUrl + "/insertdriver",
  updateDriver: settings.vlmMasterDataUrl + "/updatedriver",
  driverStatus: settings.vlmMasterDataUrl + "/driver/status",
  insertVehicle: settings.vlmMasterDataUrl + "/insertvehicle",
  updateVehicle: settings.vlmMasterDataUrl + "/updatevehicle",
  updateVehicleStatus: settings.vlmMasterDataUrl + "/vehicle/status",
  vehicleTypes: settings.vlmMasterDataUrl + "/vehicle/types",
  fleetVehicle: settings.vlmMasterDataUrl + "/vehicle",
  insertAssociations: settings.vlmMasterDataUrl + "/insertassociation",
  updateAssociation: settings.vlmMasterDataUrl + "/updateassociation",
  updateAssociationStatus: settings.vlmMasterDataUrl + "/association/status",
  checkDriverOnboarding: settings.vlmMasterDataUrl + "/driver/checkonboarding",
  requestDriverOnboarding: settings.vlmMasterDataUrl + "/driver/request",
  getFirstDriver: settings.vlmMasterDataUrl + "/firstdriver",
  countIncompleteVehicles: settings.vlmMasterDataUrl + "/vehicle/incomplete"
}